import { useEffect, useState } from "react";
import { getPaymentDetails } from "../../services/subscription.service";
import { format } from "date-fns";
import './payment.component.css';

const PaymentDetails = () => {

  const [payments, setPayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      const response = await getPaymentDetails();
      setPayments(response || []);
    } catch (error) {
      console.error("Failed to fetch payment details", error);
    }
  };

  const totalPages = Math.ceil(payments.length / pageSize);
  const currentData = payments.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const changePage = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  const renderDesktopTable = () => (
    <>
      <div className="table-responsive">
        <table className="event-notice-table">
          <thead>
            <tr>
              <th className="masterHeader" style={{ width: "10%" }}>SN</th>
              <th className="masterHeader" style={{ width: "35%" }}>Username</th>
              <th className="masterHeader" style={{ width: "25%" }}>Transaction Date & Time</th>
              <th className="masterHeader" style={{ width: "15%" }}>Amount</th>
              <th className="masterHeader" style={{ width: "15%" }}>Payment Status</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((tx, index) => (
                <tr key={tx.transactionId}>
                  <td>{(currentPage - 1) * pageSize + index + 1}</td>
                  <td>{tx.name || "Unknown"}</td>
                  <td>
                    {format(new Date(tx.createdDate), 'dd-MM-yyyy')}
                    <br />
                    {format(new Date(tx.createdDate), 'hh:mm a')}
                  </td>
                  <td>{tx.amount}</td>
                  <td>
                    <span className={tx.paymentStatus === 'S' ? "status-success" : "status-failed"}>
                      {tx.paymentStatus === 'S' ? "Success" : "Failed"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No payment data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="d-none d-md-flex justify-content-between align-items-center mt-3 px-2 mb-2">
          <span className="text-muted">
            Page {currentPage} of {totalPages}
          </span>
          <nav>
            <ul className="pagination mb-0">
              {/* Previous button */}
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => changePage(currentPage - 1)}>
                  Previous
                </button>
              </li>

              {/* Page numbers with ellipses */}
              {Array.from({ length: totalPages }, (_, i) => {
                const page = i + 1;

                if (
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 1 && page <= currentPage + 1)
                ) {
                  return (
                    <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                      <button className="page-link" onClick={() => changePage(page)}>
                        {page}
                      </button>
                    </li>
                  );
                }

                if (
                  (page === currentPage - 2 && page !== 2) ||
                  (page === currentPage + 2 && page !== totalPages - 1)
                ) {
                  return (
                    <li key={page} className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  );
                }

                return null;
              })}

              {/* Next button */}
              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => changePage(currentPage + 1)}>
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );

  const renderMobileCards = () => (
    <div className="mobile-cards">
      {payments?.map((payment, index) => (
        <div className="user-card" key={index}>
          <div className="card-row">
            <div className="paymentcard-label">Name</div>
            <div className="card-value">{payment.name}</div>
          </div>
          <div className="card-row">
            <div className="paymentcard-label">Transaction Date</div>
            <div className="card-value">
              {format(new Date(payment.createdDate), 'dd-MM-yyyy hh:mm a')}
           </div>
          </div>
          <div className="card-row">
            <div className="paymentcard-label">Amount</div>
            <div className="card-value">{payment.amount}</div>
          </div>
          <div className="card-row">
            <div className="paymentcard-label">Payment Status</div>
            <div className="card-value">
              <span className={payment.paymentStatus === 'S' ? "status-success" : "status-failed"}>
                {payment.paymentStatus === 'S' ? "Success" : "Failed"}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );


  return (
    <div className="container p-3">
      <div className="subscription-title mb-4">
        <h1>Payment Details</h1>
      </div>
      <div className="table-wrap container">
        <div className="data-container">
        {payments === null ? (
          <div className="no-data">Loading data...</div>
        ) : payments?.length > 0 ? (
          <>
            {renderDesktopTable()}
            {renderMobileCards()}
          </>
        ) : (
          <div className="no-data">
            No payment data found
          </div>
        )}
      </div>
      </div>
    </div>
  );
};

export default PaymentDetails;